<template>
  <div class="agency-sound-listener"></div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { audioClipList } from "../constants";
import { EventBus } from "@/events/eventBus";

export default {
  name: "AgencySoundListener",
  props: {
    soundSettings: {
      type: Object,
      required: true,
    },
    scope: {
      type: String,
      default: 'user', // admin or user
    },
  },
  computed: {
    ...mapGetters("user", ["volume"]),
  },
  data() {
    return {
      textNotificationSoundAudio: null,
      textTo911NotificationSoundAudio: null,
      messageNotificationSoundAudio: null,
      voiceNotificationSoundAudio: null,
      videoLeftNotificationSoundAudio: null,
      videoJoinedNotificationSoundAudio: null,
    };
  },
  created() {
    this.setSoundAudio(this.soundSettings);

    EventBus.$on(`play-text-to-911-notification-sound-${this.scope}`, () => {
      if (this.textTo911NotificationSoundAudio) {
        this.textTo911NotificationSoundAudio.pause();
        this.textTo911NotificationSoundAudio.currentTime = 0;
        this.textTo911NotificationSoundAudio.volume = this.volume;
        this.textTo911NotificationSoundAudio.play()
          .then(() => {})
          .catch((err) => {
            console.log("Playing TextTo911NotificationSoundAudio Failed", err);
          });
      }
    });
    EventBus.$on(`play-text-notification-sound-${this.scope}`, () => {
      if (this.textNotificationSoundAudio) {
        this.textNotificationSoundAudio.pause();
        this.textNotificationSoundAudio.currentTime = 0;
        this.textNotificationSoundAudio.volume = this.volume;
        this.textNotificationSoundAudio.play()
          .then(() => {})
          .catch((err) => {
            console.log("Playing TextNotificationSoundAudio Failed", err);
          });
        this.textNotificationSoundAudio.onended = () => {
          EventBus.$emit(`audio-playback-complete`);
        };
      }
    });
    EventBus.$on(`stop-text-notification-sound-${this.scope}`, () => {
      if (this.textNotificationSoundAudio) {
        this.textNotificationSoundAudio.pause();
      }
    });
    EventBus.$on(`play-message-notification-sound-${this.scope}`, () => {
      if (this.messageNotificationSoundAudio) {
        this.messageNotificationSoundAudio.pause();
        this.messageNotificationSoundAudio.currentTime = 0;
        this.messageNotificationSoundAudio.volume = this.volume;
        this.messageNotificationSoundAudio.play()
          .then(() => {})
          .catch((err) => {
            console.log("Playing MessageNotificationSoundAudio Failed", err);
          });
        this.messageNotificationSoundAudio.onended = () => {
          EventBus.$emit(`audio-playback-complete`);
        };
      }
    });
    EventBus.$on(`stop-message-notification-sound-${this.scope}`, () => {
      if (this.messageNotificationSoundAudio) {
        this.messageNotificationSoundAudio.pause();
      }
    });
    EventBus.$on(`play-voice-notification-sound-${this.scope}`, () => {
      if (this.voiceNotificationSoundAudio) {
        this.voiceNotificationSoundAudio.pause();
        this.voiceNotificationSoundAudio.currentTime = 0;
        this.voiceNotificationSoundAudio.volume = this.volume;
        this.voiceNotificationSoundAudio.play()
          .then(() => {})
          .catch((err) => {
            console.log("Playing VoiceNotificationSoundAudio Failed", err);
          });
      }
    });
    EventBus.$on(`play-video-left-notification-sound-${this.scope}`, () => {
      if (this.videoLeftNotificationSoundAudio) {
        this.videoLeftNotificationSoundAudio.pause();
        this.videoLeftNotificationSoundAudio.currentTime = 0;
        this.videoLeftNotificationSoundAudio.volume = this.volume;
        this.videoLeftNotificationSoundAudio.play()
          .then(() => {})
          .catch((err) => {
            console.log("Playing VideoLeftNotificationSoundAudio Failed", err);
          });
        this.videoLeftNotificationSoundAudio.onended = () => {
          EventBus.$emit(`audio-playback-complete`);
        };
      }
    });
    EventBus.$on(`stop-video-left-notification-sound-${this.scope}`, () => {
      if (this.videoLeftNotificationSoundAudio) {
        this.videoLeftNotificationSoundAudio.pause();
      }
    });
    EventBus.$on(`play-video-joined-notification-sound-${this.scope}`, () => {
      if (this.videoJoinedNotificationSoundAudio) {
        this.videoJoinedNotificationSoundAudio.pause();
        this.videoJoinedNotificationSoundAudio.currentTime = 0;
        this.videoJoinedNotificationSoundAudio.volume = this.volume;
        this.videoJoinedNotificationSoundAudio.play()
          .then(() => {})
          .catch((err) => {
            console.log("Playing VideoJoinedNotificationSoundAudio Failed", err);
          });
        this.videoJoinedNotificationSoundAudio.onended = () => {
          EventBus.$emit(`audio-playback-complete`);
        };
      }
    });
    EventBus.$on(`stop-video-joined-notification-sound-${this.scope}`, () => {
      if (this.videoJoinedNotificationSoundAudio) {
        this.videoJoinedNotificationSoundAudio.pause();
      }
    });
  },
  methods: {
    setVolume(volume)  {
      if (this.textNotificationSoundAudio) {
        this.textNotificationSoundAudio.volume = volume;
      }
      if (this.messageNotificationSoundAudio) {
        this.messageNotificationSoundAudio.volume = volume;
      }
      if (this.voiceNotificationSoundAudio) {
        this.voiceNotificationSoundAudio.volume = volume;
      }
      if (this.videoLeftNotificationSoundAudio) {
        this.videoLeftNotificationSoundAudio.volume = volume;
      }
      if (this.videoJoinedNotificationSoundAudio) {
        this.videoJoinedNotificationSoundAudio.volume = volume;
      }
    },
    setSoundAudio(settings) {
      const getAudioPath = (key) => {
        const setting = settings[key];
        const { value } = setting;
        const audioItem = audioClipList.find(i => i.value === value);
        return audioItem ? audioItem.path : "";
      };

      const textNotificationSoundAudio = getAudioPath('textNotificationSound');
      this.textNotificationSoundAudio = textNotificationSoundAudio ? new Audio(textNotificationSoundAudio) : null;

      const textTo911NotificationSoundAudio = getAudioPath('textTo911NotificationSound');
      this.textTo911NotificationSoundAudio = textTo911NotificationSoundAudio ? new Audio(textTo911NotificationSoundAudio) : null;

      const videoJoinedNotificationSoundAudio = getAudioPath('videoJoinedNotificationSound');
      this.videoJoinedNotificationSoundAudio = videoJoinedNotificationSoundAudio ? new Audio(videoJoinedNotificationSoundAudio) : null;

      const videoLeftNotificationSoundAudio = getAudioPath('videoLeftNotificationSound');
      this.videoLeftNotificationSoundAudio = videoLeftNotificationSoundAudio ? new Audio(videoLeftNotificationSoundAudio) : null;

      const voiceNotificationSoundAudio = getAudioPath('voiceNotificationSound');
      this.voiceNotificationSoundAudio = voiceNotificationSoundAudio ? new Audio(voiceNotificationSoundAudio) : null;

      const messageNotificationSoundAudio = getAudioPath('messageNotificationSound');
      this.messageNotificationSoundAudio = messageNotificationSoundAudio ? new Audio(messageNotificationSoundAudio) : null;
    }
  },
  watch: {
    soundSettings: {
      handler(settings) {
        this.setSoundAudio(settings);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    EventBus.$off(`play-text-notification-sound-${this.scope}`);
    EventBus.$off(`play-text-to-911-notification-sound-${this.scope}`);
    EventBus.$off(`play-message-notification-sound-${this.scope}`);
    EventBus.$off(`play-voice-notification-sound-${this.scope}`);
    EventBus.$off(`play-video-left-notification-sound-${this.scope}`);
    EventBus.$off(`play-video-joined-notification-sound-${this.scope}`);
  }
};
</script>

<style lang="scss">
.agency-sound-listener {}
</style>
